import { useMemo } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../../Utils/utils";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";

function SwachhBharatTableById() {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { id } = useParams();
  const {
    data: tableData = [],
    // energyAssetsError,
    isLoading: tableIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "fulfilling_the_swacchta_sapath",
    lang: languageType,
  });

  console.log(tableData);

  const swachhTableObj = tableData.find((item) => item.nid === id);

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(tableData);
  }, [tableData]);

  if (tableIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("Sustainable Development", "सतत विकास")}
        titleTwo={getText("Swachh Bharat Abhiyan", "स्वच्छ भारत अभियान")}
        titleLink="/sustainable-development/swachh-bharat-abhiyan"
        titleLink2={"/sustainable-development/swachh-bharat-abhiyan"}
        titleThree={swachhTableObj.title}
        levelTwo={true}
        levelThree={true}
        isActive={swachhTableObj.title}
      />
      <div className="inner-container">
        <div className="container">
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          <section className="ourCompany">
            <div className="container">
              <div className="row mb-5">
                <div
                  dangerouslySetInnerHTML={{ __html: swachhTableObj.body }}
                ></div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default SwachhBharatTableById;
